import { render, staticRenderFns } from "./setDefaultRadio.vue?vue&type=template&id=1a1a6c5f"
import script from "./setDefaultRadio.vue?vue&type=script&lang=js"
export * from "./setDefaultRadio.vue?vue&type=script&lang=js"
import style0 from "./setDefaultRadio.vue?vue&type=style&index=0&id=1a1a6c5f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports